import React from 'react';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import Button from '@mui/joy/Button';

import Success from 'components/Success';

import { FHRequestType } from 'stores/fhrequest_store';
import useFHRequest from 'hooks/useFHRequest';
import useRoles from 'hooks/useRoles';
import useWorkKey from 'hooks/useWorkKey';

import { RequestStatusSelector } from 'components/RequestOverview';

const RequestInfoUpdateStatus = ({ request, setEditing }: { request: FHRequestType, setEditing: (s: string) => void }) => {

    const workKey = useWorkKey();
    const { hasRole } = useRoles();
    const { updateStatus } = useFHRequest();
    const [saving, setSaving] = React.useState(false);
    const [status, setStatus] = React.useState(request.status);
    const [delayTime, setDelayTime] = React.useState<string|undefined>('');

    async function doSave() {
        if(!workKey) {
            return;
        }
        setSaving(true);
        await updateStatus(workKey, request.key, status, delayTime || '');
        setSaving(false);
        setEditing('');
        Success('Updating');
    }

    if(!workKey || !request) {
        return null;
    }
    if(!hasRole('support')) {
        return null;
    }


    function onUpdate(status: number, delayTime: string | undefined) {
        console.log('onUpdate', status, delayTime);
        setStatus(status);
        setDelayTime(delayTime);
    }


    return (
        <Stack
            my={2}
            spacing={2}
            alignItems="center"
        >

            <Typography
                level="title-sm">
                Update Status
            </Typography>
            <RequestStatusSelector request={request} status={status} onUpdated={onUpdate}/>

            <Stack spacing={1} direction="row" alignItems="space-between">
                <Button
                    variant={saving ? 'outlined' : undefined}
                    size="sm"
                    loading={saving}
                    onClick={doSave}
                >Save</Button>
            </Stack>
        </Stack>
    );

}

export default RequestInfoUpdateStatus;
